<template>
  <div>
    <b-form-group
      id="input-group-1"
      class="required"
      label-class="control-label"
      :label="label"
      label-for="input-1"
    ></b-form-group>
    <b-card class="text-center bg-gray-100" style="border-style: dashed;">
      <b-row
        v-if="veeErrors.first(name)"
        class="m-lg-1"
        style="background-color: #FEE8E9; border: 1px solid #ffc4c6; border-radius: 5px;"
      >
        <b-col md="12" id="img-error-report">
          <div style="width: 0%; text-align: center; vertical-align: middle; text-align:center;">
            <img
              src="@/assets/ic-warning-red.svg"
              class="ic_warning"
              style="width:25px; position:absolute; margin:auto; top:0; bottom:0;"
            />
          </div>
          <div style="width: 97%; padding-left: 3%;">
            <ul class="text-left" style="margin: 7px 0px;">
              <li class="text-danger" v-for="imageErr in veeErrors.collect(name)" :key="imageErr">
                <span class="text-dark">{{ imageErr }}</span>
              </li>
            </ul>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <img v-if="urlLocal" width="100%" height :src="urlLocal" />
          <img v-else-if="urlProps" width="100%" height :src="urlProps" />
          <img v-else width="25%" height src="@/assets/image_not_found.png" />
        </b-col>
      </b-row>
      <input
        type="file"
        :ref="`file_${name}`"
        style="display: none"
        accept="image/*"
        :name="name"
        v-validate="validateRule"
        @change="onChangeFileUpload()"
      />
      <br />
      <b-link
        @click="$refs[`file_${name}`].click()"
        v-show="(!isEdit && !file) || (isEdit && !urlProps && !file)"
        variant="primary"
        class="text-primary btn"
      >
        <img class="mr-2" src="@/assets/ic-plus.svg" alt /> <b>Select {{ label }}</b>
        <label class="text-danger">*</label>
      </b-link>
      <b-button
        v-show="(!isEdit && file) || (isEdit && (urlProps || file))"
        @click="$refs[`file_${name}`].click()"
        variant="outline-primary"
        class
      >
        <img class="mr-2" src="@/assets/ic-edit.svg" alt /> Edit
      </b-button>
      <br />
      <template v-if="$slots.desc">
        <slot name="desc" />
      </template>
      <p v-else class="text-gray-500">
        Image must be at least 1000x500 pixels and maximum 2MB. Must be in <b>JPEG</b>, <b>PNG</b>,
        or <b>GIF</b> format
      </p>
    </b-card>
  </div>
</template>

<script>
export default {
  props: {
    validator: {
      type: Object,
      required: true,
    },
    isEdit: Boolean,
    urlProps: String,
    label: String,
    name: String,
    validateRule: {
      type: String,
      default:
        "required|minimalDimensions:1000,500|ratiolDimensions:2,1|size:2000|ext:jpg,png,gif,jpeg"
    },
    file: [File, String]
  },
  inject: ['$validator'],
  data() {
    return {
      urlLocal: ""
    };
  },
  methods: {
    onChangeFileUpload() {
      const fileValue = this.$refs[`file_${this.name}`].files[0];
      const input = this.$refs[`file_${this.name}`];
      const { files } = input;
      if (files && files[0]) {
        const reader = new FileReader();
        reader.onload = e => {
          const img = new Image();
          img.src = e.target.result;
          this.urlLocal = e.target.result;
        };
        reader.readAsDataURL(files[0]);
        this.$emit("onFileChange", fileValue);
        this.$emit("onUrlChange", this.urlLocal);
      }
    }
  }
};
</script>

<style></style>
